import { LoadReasonsCancellation } from 'domain/usecases/surgical-order-cancellation/load-reasons-to-cancellation'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteLoadReasonsCancellation implements LoadReasonsCancellation {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  async load(): Promise<ReasonsCancellationModel> {
    return await this.surgicalOrderRepository.loadReasonsCancellation()
  }
}

export type ReasonsCancellationModel = LoadReasonsCancellation.Model
